export enum CollabSessionEventType {
  End = 'end',
  Start = 'start'
}
